import React from 'react'

import Select from 'react-select'

import { MaxEditor, getEditorValueAstHtml, isEditorEmpty } from '@/components/MaxEditor'
import { updateEditor } from '@/components/MaxEditor/utils'
import { useGetMessageTemplateListQuery } from '@/graphql/admin/customerMsgTemplates'
import { interpolateVarsInTemplate } from '@/utils/templates'

export function MsgTemplateEdit({ dispatch, templateVars, maxFiles = 3 }) {
  const editorRef = React.useRef(null)

  const onEditorChange = (editorState, editor) => {
    editorState.read(() => {
      if (isEditorEmpty(editor)) {
        return dispatch({ type: 'setMsgTemplate', payload: null })
      }
      const html = getEditorValueAstHtml(editor)
      dispatch({ type: 'setMsgTemplate', payload: html })
    })
  }

  const { data: msgTemplates, isLoading: isLoadingCustomerMsgTemplates } =
    useGetMessageTemplateListQuery({ isActive: true })

  const templateOptions =
    msgTemplates?.allMessageTemplates.map((t) => ({
      value: t.id,
      label: t.name,
    })) ?? []

  return (
    <>
      <div>
        <label
          htmlFor='templateOptions'
          className='text-sm'
        >
          Select Template
        </label>
        <Select
          name='templateOptions'
          className='w-full z-10'
          isDisabled={isLoadingCustomerMsgTemplates}
          options={templateOptions}
          isLoading={isLoadingCustomerMsgTemplates}
          onChange={(selectedOption: { value: string; label: string }) => {
            const editor = editorRef.current
            editor.update(() => {
              const template = msgTemplates?.allMessageTemplates.find(
                (t) => t.id === selectedOption.value
              )?.body
              const updatedTemplate = interpolateVarsInTemplate({ template, values: templateVars })
              updateEditor(editor, updatedTemplate)
            })
            dispatch({ type: 'setMsgTemplateType', payload: selectedOption.value })
          }}
        />
      </div>
      <div className='mt-3'>
        <MaxEditor
          editorRef={editorRef}
          customInitialConfig={{ namespace: 'customer-msg-editor' }}
          onChange={onEditorChange}
        />
      </div>
      <div className='mt-3'>
        <label className='form-control w-full max-w-xs'>
          <input
            type='file'
            multiple
            className='file-input file-input-bordered w-full max-w-xs'
            accept='.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpg,.jpeg'
            onChange={(e) => {
              if (e.target.files.length > maxFiles) {
                alert(`You can only upload up to ${maxFiles} files`)
                return
              }
              dispatch({
                type: 'setMsgAttachments',
                payload: { attachments: Array.from(e.target.files) },
              })
            }}
          />
          <div className='label'>
            <span className='label-text-alt'>Attach Document(s)</span>
          </div>
        </label>
      </div>
    </>
  )
}
